const contentCapabilitiesHeader = "X-Omni-Content-Capabilities";
const embedResourceCapability = "embed-resource-v1";

const contentCapabilityHeaders = {
  [contentCapabilitiesHeader]: embedResourceCapability,
};

export { contentCapabilityHeaders };
